import styles from './StatusDot.module.css';

interface StatusDotProps {
  tone: 'enabled' | 'disabled' | 'warning' | 'neutral';
  shape?: 'filled' | 'ring' | 'dash';
}

export function StatusDot({ tone, shape = 'filled' }: StatusDotProps) {
  return (
    <span
      className={`${styles.dot} ${styles[tone]} ${styles[shape]}`}
      data-testid="status-dot"
      data-tone={tone}
      data-shape={shape}
      aria-hidden="true"
    />
  );
}
